import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from '@/services/TranslationService';
import NOVOLoader from '../../shared/components/NOVOLoader';
import { changeAndPostProfile } from '../profile/actions';
import { withNOVOHeader } from '../sideMenu/HeaderHOC';
import { FALLBACK_REDIRECT_TIMEOUT_MS } from './constants';
import {
  getFallbackRedirect,
  getRedirectForAction,
} from './actionHandlers';

const RouteHandler = ({ location, setHeaderTitle }) => {
  const dispatch = useDispatch();
  const queryParams = useMemo(() => {
    const params = new URLSearchParams(location.search);

    return {
      action: params.get('action') || '',
      code: params.get('code') || '',
      authority: params.get('authority') || '',
      country: params.get('country') || '',
    };
  }, [location.search]);

  useEffect(() => {
    const title = translate('Route handler') || 'Route handler';
    setHeaderTitle?.(title);

    if (queryParams.authority || queryParams.country) {
      const updateProfile = async () => {
        try {
          await dispatch(
            changeAndPostProfile({
              authority: queryParams.authority,
              country: queryParams.country,
            })
          );
        } catch (error) {
          console.error('Failed to update profile from route handler', error);
        }
      };

      updateProfile();
    }
  }, [dispatch, queryParams.authority, queryParams.country, setHeaderTitle]);

  const redirectComponent = useMemo(
    () => getRedirectForAction(queryParams),
    [queryParams]
  );

  const [fallbackRedirect, setFallbackRedirect] = useState(false);

  useEffect(() => {
    if (queryParams.action) {
      setFallbackRedirect(false);
      return;
    }

    const timer = setTimeout(() => {
      setFallbackRedirect(true);
    }, FALLBACK_REDIRECT_TIMEOUT_MS);

    return () => clearTimeout(timer);
  }, [queryParams.action]);

  if (redirectComponent) {
    return redirectComponent;
  }

  if (fallbackRedirect) {
    return getFallbackRedirect();
  }

  return (
    <div className="flex flex-1 items-center justify-center">
      <NOVOLoader />
    </div>
  );
};

export default withNOVOHeader(withRouter(RouteHandler));
